// extracted by mini-css-extract-plugin
export var active = "styles-module--active--8368f";
export var container = "styles-module--container--0df90";
export var left = "styles-module--left--9cce0";
export var right = "styles-module--right--8f3e6";
export var row1 = "styles-module--row1--2df11";
export var row2 = "styles-module--row2--7fc01";
export var row3 = "styles-module--row3--6639e";
export var row4 = "styles-module--row4--ad12c";
export var row5 = "styles-module--row5--26e44";